import React from 'react'
import { string, number, bool } from 'prop-types'
import { createComponent, withTheme } from '@ycos/fela'
import { LOAD_STATUS } from '@ycos/constants'

// reason to add 1 px, because there a extra 1px black line , when marketing block have 1px black line at bottom (text links underline)
const DefaultLoadingTransitionBlock = createComponent('DefaultLoadingTransitionBlock', ({ fade, loadingBoxHeight, isFullbleed, theme }) => ({
  position: 'absolute',
  height: isFullbleed ? '100%' : `${loadingBoxHeight - 4 * theme.spacingMultiplier + 1}px`,
  marginTop: isFullbleed ? 0 : `${4 * theme.spacingMultiplier}px`,
  width: '100%',
  pointerEvents: 'none',
  opacity: fade ? '0' : '1',
  zIndex: 2,
  transition: 'opacity 1s'
}))

const flickerAnimation = () => ({
  '0%': { opacity: 0.5 },
  '50%': { opacity: 1 },
  '100%': { opacity: 0.5 }
})

const UserAttributesCollectionLayover = createComponent('UserAttributesCollectionLayover', ({ theme }) => ({
  position: 'absolute',
  height: '100%',
  width: '100%',
  backgroundColor: theme.typography.colors.PrimaryGrey,
  cursor: 'pointer',
  animationName: flickerAnimation(),
  animationDuration: `${theme.motionSpecs.motionDurations.t8}ms`,
  animationTimingFunction: `${theme.motionSpecs.motionGraphs.easeInOut}`,
  animationIterationCount: 'infinite'
}))

const UserAttributesCollectionBackdrop = createComponent('UserAttributesCollectionBackdrop', ({ theme }) => ({
  backgroundColor: theme.typography.colors.PrimaryWhite,
  height: '100%',
  width: '100%'
}))

export const DefaultLoadingTransition = withTheme(({ status, loadingBoxHeight, isFullbleed }) => {
  return (
    <DefaultLoadingTransitionBlock fade={status === LOAD_STATUS.LOADED} loadingBoxHeight={loadingBoxHeight} isFullbleed={isFullbleed}>
      <UserAttributesCollectionLayover />
      <UserAttributesCollectionBackdrop />
    </DefaultLoadingTransitionBlock>
  )
})

DefaultLoadingTransition.propTypes = {
  status: string,
  loadingBoxHeight: number,
  isFullbleed: bool
}

DefaultLoadingTransition.defaultProps = {
  status: LOAD_STATUS.NOTLOADED,
  loadingBoxHeight: 0,
  isFullbleed: false
}
